import React from "react"
import { formatPct, formatTimestamp} from "../utils"
import ThumbsUpDownOutlinedIcon from '@material-ui/icons/ThumbsUpDownOutlined';
import RedoIcon from '@material-ui/icons/Redo';
import SentimentSatisfiedIcon from '@material-ui/icons/SentimentSatisfied';
import TimerIcon from '@material-ui/icons/Timer';
import TimelapseIcon from '@material-ui/icons/Timelapse';
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import { OutboundLink } from "gatsby-plugin-google-gtag"

import stocktwitslogo from "../../images/stocktwits.png"

export default class SocialStats extends React.Component {
    state = {
        socialdata: null
    }  
    refreshSocialData() {
        //clear out prior data
        this.setState({socialdata:null}) 
        if (this.props.ticker !== "") { //leave component cleared out if we don't have a ticker
            this.requestSocialData();
        }
    }
    requestSocialData() {
        const url = `https://api.harsip.com/ticker/${this.props.ticker}/social/`
        return (fetch(url)
            .then(res => res.json())
            .then((data) => {
              this.setState({ socialdata: data }) 
            })
         .catch(console.log))
     }
   
    componentDidUpdate(prevProps) {
        if (prevProps.ticker !== this.props.ticker) { //ticker has changed
                this.refreshSocialData()
        }
    }
    componentDidMount() {
        this.refreshSocialData()
    }
    
    
    render(){
        let socialData=null;
        if (this.state) socialData = this.state.socialdata;

        if (!socialData) {
            return <div><CircularProgress variant="indeterminate" thickness={2.0} color="primary" /></div>
        }
        
        return (
            <div>
                 
                 <h6 className="card-subtitle">Analyzing the last {socialData.messageCount} messages on <OutboundLink href={'https://stocktwits.com/symbol/'+this.props.ticker} rel="noreferrer noopener"  target='_blank'>
                    <img src={stocktwitslogo}  style={{verticalAlign:"middle"}} height="25" alt="stockTwits"/></OutboundLink>
                </h6>
                
                <div className="font-light">
                    <h6 className="card-title">Sentiment metrics</h6>
                    <table width='100%'>
                        <tbody>
                            <tr>
                                <td>Bear/bull ratio:</td>
                                <td><Tooltip title="Of the posts for which sentiment can be determined, how many are bullish vs. bearish">
                                    <ThumbsUpDownOutlinedIcon style={{  fontSize:20, color: "#cccccc" }} />
                                    </Tooltip>
                                    </td>
                                <td>{formatPct(socialData.sentiment.bearRatio*100)}  /  {formatPct(socialData.sentiment.bullRatio*100)} </td>
                            </tr>
                            <tr>
                                <td>No sentiment:</td>

                                <td><Tooltip title="Many posts don't declare a sentiment">
                                    <SentimentSatisfiedIcon style={{  fontSize:20, color: "#cccccc" }}/>
                                </Tooltip>
                                </td>
                                <td>{formatPct(socialData.sentiment.noSentiment*100)} </td>
                            </tr>
                            <tr>
                                <td>Reference other tickers:</td>
                                <td><Tooltip title={"How many of these posts also refer to other tickers (and thus might not strictly be about "+this.props.ticker+"?"} >
                                    <RedoIcon style={{ fontSize:20, color: "#cccccc" }}/>
                                    </Tooltip>
                                    </td>
                                <td>{formatPct( (socialData.crossRef.count/socialData.messageCount)*100)} </td>
                            </tr>
                        </tbody>
                    </table>
                    <h6 className="card-title">Message Velocity:</h6>
                    <table width="100%">
                    <tbody>
                        <tr><td>Time since last post</td>
                            <td><Tooltip title={"Time since last post tells us whether anyone is actively discussing "+this.props.ticker} >
                                <TimelapseIcon style={{ fontSize:20, color: "#cccccc" }}/>
                                </Tooltip>
                                </td>
                            <td>{formatTimestamp(socialData.messageVelocity.lastPostAge)}</td>
                        </tr>
                        <tr><td>100 posts in the last:</td>
                            <td><Tooltip title={"The age of the 100th most recent post tells us how rapidly people are posting about "+this.props.ticker}>
                                <TimerIcon style={{ fontSize:20, color: "#cccccc" }}/>
                                </Tooltip>
                            </td>
                            <td>{formatTimestamp(socialData.messageVelocity.hundredthPostAge)}</td></tr>
                    </tbody>
                    </table>
           

            </div>
        </div>
        )
    }
}